var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.671 0 .984 6.66a20.799 20.799 0 0 0 17.537 17.537l6.66.984-6.66.983a20.799 20.799 0 0 0-17.537 17.537l-.984 6.66-.983-6.66A20.799 20.799 0 0 0 13.15 26.164l-6.66-.983 6.66-.984A20.799 20.799 0 0 0 30.688 6.66L31.67 0Z",
    fill: "url(#stars_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.6 33.349.443 2.996a9.356 9.356 0 0 0 7.888 7.888l2.996.443-2.996.442a9.356 9.356 0 0 0-7.889 7.889l-.442 2.996-.443-2.996a9.356 9.356 0 0 0-7.888-7.889l-2.996-.442 2.996-.443a9.356 9.356 0 0 0 7.888-7.888l.443-2.996Z",
    fill: "url(#stars_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.3 4.936.285 1.93a6.03 6.03 0 0 0 5.084 5.085l1.931.285-1.93.285a6.03 6.03 0 0 0-5.085 5.084L7.3 19.536l-.285-1.93A6.03 6.03 0 0 0 1.93 12.52L0 12.236l1.93-.285a6.03 6.03 0 0 0 5.085-5.084L7.3 4.936Z",
    fill: "url(#stars_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__a",
    x1: 6.475,
    y1: 25.169,
    x2: 56.855,
    y2: 25.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#FACD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B410"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__b",
    x1: 3.266,
    y1: 44.67,
    x2: 25.928,
    y2: 44.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#FACD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B410"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__c",
    x1: -0.005,
    y1: 12.232,
    x2: 14.601,
    y2: 12.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#FACD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B410"
  })))));
};

export default SvgStars;